import { VisitorRegistrationQRCodeComponent } from './terminal/visitor-registration-qrcode/visitor-registration-qrcode.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VisitRolesModule } from '../components/visit-roles/visit-roles.module';
import { VisitRolesAdminWidgetComponent } from './visit-roles-admin-widget.component';



@NgModule({
  declarations: [
    VisitRolesAdminWidgetComponent
  ],
  imports: [
    CommonModule,
    VisitRolesModule
  ]
})
export class TMCVisitWidgetsModule { }
